module.exports = __webpack_public_path__ + "img/29.6ae18132.jpg";